type MessagePayload = {
  message?: unknown;
};

const readMessage = (payload: unknown): string | null => {
  if (!payload || typeof payload !== 'object') return null;

  const message = (payload as MessagePayload).message;
  if (typeof message !== 'string') return null;

  const trimmedMessage = message.trim();
  return trimmedMessage || null;
};

export const getResponseMessage = (response: unknown, fallbackMessage: string): string => {
  return readMessage(response) || fallbackMessage;
};

export const getErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const responseData = (error as { response?: { data?: unknown } })?.response?.data;
  return readMessage(responseData) || fallbackMessage;
};
